module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAkCAMAAADW3miqAAAAXVBMVEUAAAB6enp4eHh3d3d/f394eHh/f393d3d3d3d4eHh3d3d5eXl5eXl0dHR4eHh4eHh4eHh4eHh3d3d4eHh2dnZ4eHh5eXl4eHh3d3d3d3d3d3d4eHh4eHh2dnZ4eHizHz4WAAAAHnRSTlMAMN8gEO8IQIDP9yhQGHC/n2hgp1jHj6/Xt3hI5zjOIjJiAAAAwUlEQVR42rXOVWLDQAyE4TEzbDhxO/c/Zs2oVfl7/gX4P1EnhF32Sjh43ByIvDPXKimLU+7c9lf9O4+uBdb8hBLXw8qTsmR1MaZNjYmT0iqaojvtkmkRNbn4kfzVg5og7JqCuvcuiqg7ddGFulcXGeriLjpRF3/5p4y6Bp2AmtRHp6amQi+nxmCQ0O4txOerSkzOtLli5ruUBR4WWUBJGmHNkXYFXbPmV9xLPBxcXK4FJSSheXKSlD5s/CjuNAW+7QPQjFx1aIfd0AAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/paramIcon/实心圆.png
// module id = Mbr5
// module chunks = 2